import template   from './carousel.html'
import controller from './carousel.controller'
import './carousel.styl'

let component = {
  restrict: 'E',
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/catalog/components/carousel/carousel.component.js